export const classes = {
  shiftsHeader: {
    display: 'flex',
    justifyContent: 'center',
  },
  shiftsHeaderTitle: {
    flex: 1,
  },
}
